import { Component } from 'preact'

import { editContent } from '../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
import { Reply } from '../interfaces'
import PinnedReplyInContent from './PinnedReplyInContent'

/* eslint-disable import/no-internal-modules */
import Content from '@insided/deprecated-preact-components/common/Content'
import Editor from '@insided/deprecated-preact-components/editor'

export interface OpeningPostContentProps {
  topicId: number
  contentType: ContentType
  content: string | null
  pinnedReply?: Reply | null
  showEditor: boolean
  onChangeContent: (content: string) => void
  onCancel: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface PostContentState {
  content: string | null
  isLoading: boolean
}

class OpeningPostContent extends Component<OpeningPostContentProps, PostContentState> {
  constructor (props: OpeningPostContentProps) {
    super(props)
    this.state = {
      content: props.content,
      isLoading: false
    }
    this.onChange = this.onChange.bind(this)
    this.onSaveChanges = this.onSaveChanges.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onChange (content: string) {
    this.setState({ content })
  }

  async onSaveChanges () {
    const { contentType, topicId, onChangeContent, onCancel, onShowAlert } = this.props
    const { content } = this.state
    this.setState({ isLoading: true })
    try {
      await editContent(contentType, topicId, String(content))
      onChangeContent(String(content))
      onCancel()
    } catch {
      onShowAlert('error')
    }
    this.setState({ isLoading: false })
  }

  onCancel () {
    const { content, onCancel } = this.props
    this.setState({ content })
    onCancel()
  }

  render () {
    const { showEditor, pinnedReply } = this.props
    const { content, isLoading } = this.state
    return (
      <div className='post--content post--content-new-editor'>
        {
          showEditor
            ? (
              <Editor
                isControl
                data={content}
                isLoading={isLoading}
                attachments={[]}
                canHavePoll={false}
                onChange={this.onChange}
                onSubmit={this.onSaveChanges}
                onCancel={this.onCancel}
                profile='openingPost'
              />
              )
            : (
              <div>
                <Content content={content ?? ''} className='qa-post-content' isControl />
                {pinnedReply &&
                  <PinnedReplyInContent
                    author={pinnedReply.author}
                    content={pinnedReply.content}
                    repliedAt={pinnedReply.repliedAt}
                  />}
              </div>
              )
          }
      </div>
    )
  }
}

export default OpeningPostContent
